var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.details.length
    ? _c(
        "section",
        { staticClass: "source-details" },
        [
          _c("h4", [_vm._v("Source Details")]),
          _vm._l(_vm.details, function(evidence, index) {
            return _c("div", { key: index, staticClass: "evidence" }, [
              _vm.details.length > 1
                ? _c("h5", [_vm._v("Evidence " + _vm._s(index + 1))])
                : _vm._e(),
              _c(
                "dl",
                _vm._l(evidence, function(field) {
                  return _c("div", { key: field.label, staticClass: "field" }, [
                    _c("dt", [_vm._v(_vm._s(field.label))]),
                    _c(
                      "dd",
                      [
                        field.href
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: field.href,
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }
                              },
                              [_vm._v(" " + _vm._s(field.value) + " ")]
                            )
                          : [_vm._v(_vm._s(field.value))]
                      ],
                      2
                    )
                  ])
                }),
                0
              )
            ])
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }